export type TemplateKind = "sms" | "voice" | "email";

export function isTemplateKind(value: any): value is TemplateKind {
    return value === "sms" || value === "voice" || value === "email";
}
